class LazyVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const $video = entry.target;
          if (entry.isIntersecting && $video.play) {
            $video.setAttribute("poster", $video.getAttribute("data-poster"));
            $video.play();
          }
        });
      },
      {
        rootMargin: "-100px",
      }
    );

    this.querySelectorAll("[data-lazy-video]").forEach((video) => {
      observer.observe(video);
    });
  }
}

customElements.define("lazy-video", LazyVideo);
